import { useQuery } from '@apollo/client';
import { notEmpty } from '@crehana/utils';

import GET_SKILL_XP_USER_RESULT_BY_TAG from '../graphql/GetSkillXPUserResultByTag.graphql';
import type {
  GetSkillXPUserResultByTag,
  GetSkillXPUserResultByTagVariables,
} from '../graphql/types/GetSkillXPUserResultByTag';

const useSkillXPUserResultByTag = ({
  trackId,
  skillClose,
}: {
  trackId: number;
  skillClose?: boolean;
}) => {
  const { data, loading, error, refetch } = useQuery<
    GetSkillXPUserResultByTag,
    GetSkillXPUserResultByTagVariables
  >(GET_SKILL_XP_USER_RESULT_BY_TAG, {
    variables: {
      trackId,
      skillClose,
    },
  });

  const graphData =
    data?.skillB2BUserResultTag
      ?.filter(notEmpty)
      // TODO: talk with the code owner to fix this code so we can enable this rule again

      .map(({ __typename, ...rest }) => rest) || [];

  return {
    graphData,
    loading,
    error,
    refetch,
  };
};

export default useSkillXPUserResultByTag;
